import { Link } from "react-router-dom";
import { SITE, scrollToId } from "@/lib/site";

const LINKS = [
  { label: "Collections", id: "collections" },
  { label: "Gold Rates", id: "rates" },
  { label: "Swarna Nidhi 11+1", id: "scheme" },
  { label: "Heritage", id: "heritage" },
  { label: "Private Viewing", id: "contact" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-[#D4AF37]/15 bg-[#060B18]">
    <div className="pointer-events-none select-none px-4 pt-14 text-center">
      <p
        data-testid="footer-watermark"
        className="font-serif text-[15vw] leading-[0.8] text-transparent lg:text-[11rem]"
        style={{ WebkitTextStroke: "1px rgba(212,175,55,0.22)" }}
      >
        ARADHANA
      </p>
    </div>
    <div className="mx-auto grid max-w-7xl gap-12 px-6 pb-16 pt-10 sm:grid-cols-2 lg:grid-cols-4 lg:px-12">
      <div>
        <img src="/assets/logo-full.png" alt="Aradhana Jewellers" className="h-20 w-auto rounded-xl border border-[#D4AF37]/20" />
        <p className="mt-5 max-w-xs text-xs font-light leading-relaxed text-[#79756E]">
          Pure 916 hallmark gold and certified solitaires, consecrated by hand at the Aradhana atelier.
        </p>
      </div>
      <div>
        <p className="eyebrow mb-5">Explore</p>
        <ul className="space-y-3">
          {LINKS.map((l) => (
            <li key={l.id}>
              <button
                data-testid={`footer-link-${l.id}`}
                onClick={() => scrollToId(l.id)}
                className="text-sm font-light text-[#B5B0A8] transition-colors hover:text-[#E6C265]"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <p className="eyebrow mb-5">Showroom</p>
        <ul className="space-y-3 text-sm font-light text-[#B5B0A8]">
          <li>
            <a data-testid="footer-map-link" href={SITE.mapLink} target="_blank" rel="noreferrer" className="transition-colors hover:text-[#E6C265]">
              {SITE.address}
            </a>
          </li>
          <li>{SITE.hours}</li>
          <li>
            <a data-testid="footer-phone-link" href={`tel:${SITE.phoneRaw}`} className="transition-colors hover:text-[#E6C265]">
              {SITE.phoneDisplay}
            </a>
          </li>
          <li>
            <a data-testid="footer-email-link" href={`mailto:${SITE.email}`} className="transition-colors hover:text-[#E6C265]">
              {SITE.email}
            </a>
          </li>
        </ul>
      </div>
      <div>
        <p className="eyebrow mb-5">Assurance</p>
        <ul className="space-y-3 font-mono text-xs text-[#79756E]">
          <li>BIS Hallmarked Jewellery</li>
          <li data-testid="footer-gstin">GSTIN · {SITE.gst}</li>
          <li>IGI · SGL Certified Diamonds</li>
          <li>
            <Link data-testid="footer-admin-link" to="/admin" className="text-[#99732B] transition-colors hover:text-[#E6C265]">
              Atelier Console →
            </Link>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/5 px-6 py-6 lg:px-12">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 text-[11px] font-light text-[#79756E] sm:flex-row">
        <p data-testid="footer-copyright">© 2026 Shree Aradhana Jewellers · {SITE.domain}</p>
        <p>Gold &amp; silver rates are indicative and change with the market. Final billing at showroom board rate.</p>
      </div>
    </div>
  </footer>
);
